import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MarkdownComponent } from 'ngx-markdown';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-markdown-rules-dialog',
  template: `
    <div
      class="w-100 d-flex justify-content-between align-items-start dialog-header"
    >
      <h2 class="align-items-center d-flex p-0 m-0">
        <mat-icon class="material-symbols-rounded">markdown</mat-icon> &nbsp;
        {{ 'MISC_DIALOGS.MARKDOWN_RULES.TITLE' | translate }}
      </h2>
      <span
        class="icon-smap-action-close close-button"
        (click)="closeDialog()"
        [matTooltip]="'SHARE_DIALOG.CLOSE_TOOLTIP' | translate"
      ></span>
    </div>

    <div #scrollBox class="p-3 md-content">
      <markdown [data]="markdownContent"></markdown>
    </div>
  `,
  styles: [
    `
      .md-content {
        height: 50vh;
        overflow: auto;
      }
    `,
  ],
  preserveWhitespaces: true,
  standalone: true,
  imports: [
    MatIcon,
    MatTooltip,
    MarkdownComponent,
    TranslatePipe
  ]
})
export class MarkdownRulesDialogComponent implements AfterViewInit {
  public markdownContent = '';

  @ViewChild('scrollBox') scrollBox!: ElementRef<HTMLElement>;

  constructor(
    private dialogRef: MatDialogRef<MarkdownRulesDialogComponent>,
    private httpClient: HttpClient
  ) {}

  ngAfterViewInit() {
    // Wait until dialog is fully opened
    this.dialogRef.afterOpened().subscribe(() => {
      // Load markdown
      this.httpClient
        .get('assets/markdown/MARKDOWN-RULES.MD', {
          responseType: 'text',
        })
        .subscribe((data: string) => {
          this.markdownContent = data;

          // Let Angular render the markdown, then scroll
          setTimeout(() => {
            if (this.scrollBox?.nativeElement) {
              this.scrollBox.nativeElement.scrollTop = 0;
            }
          }, 100);
        });
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
